var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetProfileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 141,
    viewBox: "0 0 188 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 186,
    height: 139,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.938 56.5C108.188 56.5 109.938 58.3125 109.938 60.5V80.5C109.938 82.75 108.125 84.5 105.938 84.5H81.9375C79.75 84.5 77.9375 82.75 77.9375 80.5V60.5C77.9375 58.3125 79.75 56.5 81.9375 56.5H105.938ZM84.9375 60.5C83.3125 60.5 81.9375 61.875 81.9375 63.5C81.9375 65.1875 83.1875 66.5 84.9375 66.5C86.625 66.5 87.9375 65.1875 87.9375 63.5C87.9375 61.875 86.5625 60.5 84.9375 60.5ZM105.875 80C106 79.6875 106 79.25 105.812 79L97.8125 67C97.625 66.6875 97.3125 66.5 97 66.5C96.625 66.5 96.3125 66.6875 96.125 67L90.3125 75.75L88.25 72.9375C88.0625 72.6875 87.8125 72.5 87.5 72.5C87.125 72.5 86.875 72.6875 86.6875 72.9375L82.3125 78.9375C82.0625 79.25 82.0625 79.625 82.1875 80C82.375 80.3125 82.6875 80.5 83.125 80.5H105C105.312 80.5 105.688 80.3125 105.875 80Z",
    fill: "#94A9E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 186,
    height: 139,
    rx: 5,
    stroke: "#94A9E8",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProfileBg);
export default __webpack_public_path__ + "static/media/pet-profile-bg.dfaf9a07cd24d32f38934c69099dd2a0.svg";
export { ForwardRef as ReactComponent };